import {
  useQuery,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import * as api from '../api/vendors';

export const useVendors = (params) =>
  useQuery({
    queryKey: ['vendors', params],
    queryFn: () =>
      api.getVendorsPaginated({ ...params, page: 1, limit: 200 }).then((r) => r.data),
  });

export const useVendorsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['vendors', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getVendorsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useVendor = (uuid) =>
  useQuery({
    queryKey: ['vendors', uuid],
    queryFn: () => api.getVendor(uuid),
    enabled: !!uuid,
  });

export const useCreateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.createVendor(data),
    onSuccess: (created) => {
      qc.setQueryData(['vendors', created.uuid], created);
      qc.invalidateQueries({ queryKey: ['vendors'] });
    },
  });
};

export const useUpdateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ uuid, data }) => api.updateVendor(uuid, data),
    onSuccess: (updated, { uuid }) => {
      qc.setQueryData(['vendors', uuid], updated);
      qc.invalidateQueries({ queryKey: ['vendors'] });
    },
  });
};

export const useDeactivateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.deactivateVendor(uuid),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vendors'] }),
  });
};

export const useActivateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.activateVendor(uuid),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vendors'] }),
  });
};

export const useDeleteVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.deleteVendor(uuid),
    onSuccess: (_, uuid) => {
      qc.removeQueries({ queryKey: ['vendors', uuid] });
      qc.invalidateQueries({ queryKey: ['vendors'] });
    },
  });
};
